[
  {
    "id": 1,
    "name": "谢征",
    "relation_type": "强者克制·并肩守护",
    "one_liner": "他不会把你藏在身后，而是会把刀递给你，然后站在离你最近的位置。",
    "why_him": "你真正需要的不是替你过人生的拯救者，而是一个足够强、又尊重你强大的人。",
    "why_attracted": "你不会只看他的能力和位置，也能看见那个一直扛事、很少允许自己累的人。",
    "how_love": "不黏、不废话，真正需要的时候往往已经开始行动。",
    "sweet_scene": "所有人都以为这是你自己的战场，回头时他已经站在旁边，只说一句“走”。",
    "flaw": "责任太重，习惯自己扛，很多事情不提前告诉你。",
    "conflict": "为什么这么大的事情你又最后一个告诉我？",
    "advice": "让他明白分享风险不等于把风险丢给你。",
    "final_line": "你不需要等一个踩着祥云的人。真正适合你的那个人，会在你准备自己杀出去的时候，和你站到同一边。",
    "front_cards": {
      "偏爱浓度": 93,
      "守护行动力": 96,
      "情绪理解力": 78,
      "心动危险值": 66
    },
    "vector": {
      "E": 58,
      "M": 72,
      "A": 95,
      "D": 76,
      "S": 82,
      "R": 66,
      "I": 82,
      "C": 92,
      "H": 38,
      "G": 74
    },
    "theme": "铁血将军系",
    "keywords": [
      "铁血守护",
      "运筹帷幄",
      "忠诚担当"
    ],
    "result_bg": "/assets/heroes/01_谢征_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/01_谢征_result_bg.png"
  },
  {
    "id": 2,
    "name": "公孙鄞",
    "relation_type": "温润谋士·清醒克制",
    "one_liner": "别人家的盖世英雄负责拔刀，你这个更擅长先把整盘棋看明白。",
    "why_him": "你更容易被聪明却不拿聪明压你、看得透却不急着拆穿你的人打动。",
    "why_attracted": "你能看见他从容底下的疲惫，也允许他偶尔不做最清醒的人。",
    "how_love": "会记住细节，卡住时不塞答案，而是顺手把最难的一步铺平。",
    "sweet_scene": "你还在犹豫，他把茶推过来：“你想做，就做。剩下的我来想。”",
    "flaw": "太能忍，明明很在意却像只是顺手照顾。",
    "conflict": "你到底什么时候才能把话说清楚？",
    "advice": "两个都克制的人别谈猜谜恋爱，总得有人先开口。",
    "final_line": "真正适合你的，不一定是最声势浩大的人，而是那个在你还没发现风雨的时候，已经替你把伞放在手边的人。",
    "front_cards": {
      "偏爱浓度": 88,
      "守护行动力": 75,
      "情绪理解力": 91,
      "心动危险值": 52
    },
    "vector": {
      "E": 52,
      "M": 91,
      "A": 74,
      "D": 44,
      "S": 77,
      "R": 45,
      "I": 94,
      "C": 78,
      "H": 55,
      "G": 63
    },
    "theme": "温润公子系",
    "keywords": [
      "温润清醒",
      "洞察人心",
      "谋定后动"
    ],
    "result_bg": "/assets/heroes/02_公孙鄞_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/02_公孙鄞_result_bg.png"
  },
  {
    "id": 3,
    "name": "李长寿",
    "relation_type": "极致稳健·苟道智囊",
    "one_liner": "他不是不来救你，他只是想先确认救你的方案有没有至少三条撤退路线。",
    "why_him": "真正落到生活里，你更需要先活下来再谈浪漫的可靠感。",
    "why_attracted": "你理解他的谨慎不是怂，也不会逼他用冒险证明勇敢。",
    "how_love": "药、符、退路、Plan B 全都提前准备，爱更像风险管理。",
    "sweet_scene": "你以为事情完蛋了，他又掏出一个备用方案：“其实我还准备了一个。”",
    "flaw": "太谨慎，浪漫也容易变成项目管理。",
    "conflict": "你觉得他偶尔该冲动一次，他觉得为什么一定要用生命证明爱情。",
    "advice": "偶尔允许他稳，也偶尔把他从计划表里拽出来。",
    "final_line": "别人给你一场轰轰烈烈的爱情，他可能更想给你一个能一起安全活到大结局的人生。",
    "front_cards": {
      "偏爱浓度": 84,
      "守护行动力": 91,
      "情绪理解力": 70,
      "心动危险值": 28
    },
    "vector": {
      "E": 38,
      "M": 66,
      "A": 88,
      "D": 32,
      "S": 86,
      "R": 20,
      "I": 100,
      "C": 84,
      "H": 78,
      "G": 60
    },
    "theme": "智谋权谋系",
    "keywords": [
      "运筹帷幄",
      "洞察人心",
      "步步为营"
    ],
    "result_bg": "/assets/heroes/03_李长寿_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/03_李长寿_result_bg.png"
  },
  {
    "id": 4,
    "name": "赵凌",
    "relation_type": "野生生命力·共同逆袭",
    "one_liner": "别人家的英雄出生就是侯爷，你家的比较励志——得从第一集自己往上爬。",
    "why_him": "你不太吃天生完美，更容易被摔过、穷过、狼狈过但就是没趴下的人吸引。",
    "why_attracted": "你看重一个人怎么走，而不是从哪里出发。",
    "how_love": "有饭一起吃，有事一起扛，出事就卷袖子先干。",
    "sweet_scene": "最狼狈的时候坐路边，你问以后怎么办，他说“往前走呗”，把最后一半吃的递给你。",
    "flaw": "有时太糙，不一定懂你细腻的小心思。",
    "conflict": "你觉得他不够细腻，他觉得一句话为什么要猜三层。",
    "advice": "需求要说清楚，别让务实型伴侣靠猜。",
    "final_line": "你等的也许不是一个从天而降的人，而是一个和你从泥里爬出来以后，还愿意牵着你继续往前走的人。",
    "front_cards": {
      "偏爱浓度": 87,
      "守护行动力": 89,
      "情绪理解力": 73,
      "心动危险值": 48
    },
    "vector": {
      "E": 76,
      "M": 70,
      "A": 88,
      "D": 58,
      "S": 72,
      "R": 52,
      "I": 62,
      "C": 70,
      "H": 84,
      "G": 96
    },
    "theme": "鲜活成长系",
    "keywords": [
      "野生生命力",
      "共同逆袭",
      "直球担当"
    ],
    "result_bg": "/assets/heroes/04_赵凌_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/04_赵凌_result_bg.png"
  },
  {
    "id": 5,
    "name": "谢燕来",
    "relation_type": "孤狼逆袭·成长型英雄",
    "one_liner": "系统没有给你分一个出厂满级男主，给你分了一个会一路长成英雄的人。",
    "why_him": "你容易被带刺、被现实磨过却不认命的人吸引，你想看到的是成长。",
    "why_attracted": "你不急着改造他，能看见防备背后那个很早学会靠自己的人。",
    "how_love": "嘴上不一定好听，但“我自己来”会慢慢变成“我们一起”。",
    "sweet_scene": "你准备自己扛事，他皱眉：“你是不是又准备一个人去？”然后拿刀：“走。”",
    "flaw": "防备心重，示弱很难。",
    "conflict": "明明撑不住了还说没事。",
    "advice": "别逼他立刻会表达，但要建立求助和共享风险的习惯。",
    "final_line": "有些英雄不是为了等你才成为英雄，而是在遇见你以后，突然有了更想赢下去的理由。",
    "front_cards": {
      "偏爱浓度": 91,
      "守护行动力": 93,
      "情绪理解力": 66,
      "心动危险值": 63
    },
    "vector": {
      "E": 48,
      "M": 58,
      "A": 92,
      "D": 65,
      "S": 63,
      "R": 68,
      "I": 58,
      "C": 82,
      "H": 47,
      "G": 95
    },
    "theme": "鲜活成长系",
    "keywords": [
      "孤狼成长",
      "行动守护",
      "逆风翻盘"
    ],
    "result_bg": "/assets/heroes/05_谢燕来_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/05_谢燕来_result_bg.png"
  },
  {
    "id": 6,
    "name": "雷修远",
    "relation_type": "温柔假面·危险反转",
    "one_liner": "好消息：他确实是冲你来的。坏消息：最开始可能不是因为爱情。",
    "why_him": "你容易被有第二层、表面温和但偶尔露出危险面的人吸引。",
    "why_attracted": "你不是那么容易被表面骗过去，却在看见真实一面后没有立刻走。",
    "how_love": "前期真真假假，后来连他自己都分不清什么时候开始认真。",
    "sweet_scene": "你问“当时接近我是不是故意的？”他说“最开始是。后来不是。”",
    "flaw": "信任成本很高。",
    "conflict": "你分不清他的温柔到底哪句是真的。",
    "advice": "高浓度关系必须建立在坦白上，而不是靠反转维持刺激。",
    "final_line": "最危险的从来不是他带着目的靠近你，而是有一天，他突然发现自己已经舍不得完成原来的计划。",
    "front_cards": {
      "偏爱浓度": 92,
      "守护行动力": 82,
      "情绪理解力": 72,
      "心动危险值": 91
    },
    "vector": {
      "E": 56,
      "M": 70,
      "A": 80,
      "D": 68,
      "S": 55,
      "R": 92,
      "I": 85,
      "C": 66,
      "H": 38,
      "G": 62
    },
    "theme": "危险宿命系",
    "keywords": [
      "温柔假面",
      "危险反转",
      "高浓心动"
    ],
    "result_bg": "/assets/heroes/06_雷修远_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/06_雷修远_result_bg.png"
  },
  {
    "id": 7,
    "name": "藏海",
    "relation_type": "隐忍谋局·长线主义",
    "one_liner": "别人谈恋爱走一步看一步，他可能连你们三年后的风险都顺手算了。",
    "why_him": "你容易被真正脑子好用、越乱越冷静的人吸引。",
    "why_attracted": "你理解总在计划未来不代表没有感情；把你纳入未来本身就是重选择。",
    "how_love": "爱像把你逐渐写进整盘人生计划。",
    "sweet_scene": "原来只想“我怎么走”，后来所有方案里都变成“我们怎么走”。",
    "flaw": "什么都藏，计划、风险、心事都藏。",
    "conflict": "为什么每次都是事情结束以后才告诉我？",
    "advice": "把“保护”升级成共同知情，而不是单方面替对方决定。",
    "final_line": "他最浪漫的地方，可能不是说了什么，而是在所有未来方案里，都悄悄给你留了位置。",
    "front_cards": {
      "偏爱浓度": 86,
      "守护行动力": 84,
      "情绪理解力": 68,
      "心动危险值": 70
    },
    "vector": {
      "E": 35,
      "M": 61,
      "A": 82,
      "D": 62,
      "S": 58,
      "R": 69,
      "I": 99,
      "C": 94,
      "H": 28,
      "G": 70
    },
    "theme": "智谋权谋系",
    "keywords": [
      "隐忍谋局",
      "深思熟虑",
      "长线布局"
    ],
    "result_bg": "/assets/heroes/07_藏海_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/07_藏海_result_bg.png"
  },
  {
    "id": 8,
    "name": "魏劭",
    "relation_type": "强势枭雄·真香彻底",
    "one_liner": "这个人最开始有多难搞，后面栽进去的时候可能就有多彻底。",
    "why_him": "你真正容易上头的是势均力敌、有立场有冲突但愿意为你修正判断的人。",
    "why_attracted": "你不是一味顺着他的人，这对习惯掌控的人反而最有吸引力。",
    "how_love": "前期“没得商量”，后期开始问你到底想怎么做。",
    "sweet_scene": "嘴硬到最后却一次次为你改决定。",
    "flaw": "控制欲容易超标。",
    "conflict": "这是我的事情 / 所以我才管。",
    "advice": "强强关系要学会双向让出控制权。",
    "final_line": "真正让强者认输的，从来不是更强的人，而是那个让他第一次心甘情愿改变决定的人。",
    "front_cards": {
      "偏爱浓度": 95,
      "守护行动力": 94,
      "情绪理解力": 61,
      "心动危险值": 83
    },
    "vector": {
      "E": 61,
      "M": 56,
      "A": 94,
      "D": 88,
      "S": 73,
      "R": 84,
      "I": 72,
      "C": 89,
      "H": 30,
      "G": 66
    },
    "theme": "铁血将军系",
    "keywords": [
      "强势护短",
      "铁血担当",
      "真香专一"
    ],
    "result_bg": "/assets/heroes/08_魏劭_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/08_魏劭_result_bg.png"
  },
  {
    "id": 9,
    "name": "蒋长扬",
    "relation_type": "成熟松弛·靠谱托底",
    "one_liner": "他最危险的地方，是你前面十集可能都没发现他已经认真了。",
    "why_him": "你喜欢懂人情世故、会开玩笑、知道什么时候认真也知道什么时候松弛的人。",
    "why_attracted": "你能看见他“什么都不在乎”的表面下其实一直在替别人收尾。",
    "how_love": "平时很松，真正大事来时却稳稳接住。",
    "sweet_scene": "大家散了你才说“其实刚刚我有点怕”，他收起笑：“我知道。”",
    "flaw": "太会装没事，让人怀疑他到底有多认真。",
    "conflict": "你想确认，他却总用玩笑带过去。",
    "advice": "需要时把真实情绪说出来，别让松弛变成回避。",
    "final_line": "真正成熟的偏爱，不一定时时刻刻围着你转，而是在你转身的时候，发现他从来没真的走远。",
    "front_cards": {
      "偏爱浓度": 89,
      "守护行动力": 85,
      "情绪理解力": 86,
      "心动危险值": 57
    },
    "vector": {
      "E": 77,
      "M": 85,
      "A": 84,
      "D": 58,
      "S": 81,
      "R": 56,
      "I": 87,
      "C": 78,
      "H": 88,
      "G": 72
    },
    "theme": "温润公子系",
    "keywords": [
      "成熟松弛",
      "靠谱托底",
      "温柔坚定"
    ],
    "result_bg": "/assets/heroes/09_蒋长扬_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/09_蒋长扬_result_bg.png"
  },
  {
    "id": 10,
    "name": "许七安",
    "relation_type": "嘴贫活人·欢喜冤家",
    "one_liner": "别人家的男主负责深情凝视，你家的深情到第三秒可能自己先笑场。",
    "why_him": "你怕关系太端着，更喜欢能说废话、能玩梗、真有事又靠谱的人。",
    "why_attracted": "你接得住他的梗，也看得见玩笑底下真正认真的部分。",
    "how_love": "损你、逗你、陪你发疯，需要时迅速切换到靠谱模式。",
    "sweet_scene": "你紧张得不行，他一路说烂话，烦得你想骂他，却发现自己真的没那么怕了。",
    "flaw": "嘴太欠，正经情话说不过三秒就破坏气氛。",
    "conflict": "你想认真聊，他总先开玩笑。",
    "advice": "把玩笑当润滑剂，不要当逃避情绪的挡箭牌。",
    "final_line": "好的爱情不一定让你每天活在偶像剧里，也可能只是让原本很难熬的人生，多了一个特别好笑的队友。",
    "front_cards": {
      "偏爱浓度": 88,
      "守护行动力": 88,
      "情绪理解力": 81,
      "心动危险值": 49
    },
    "vector": {
      "E": 91,
      "M": 78,
      "A": 87,
      "D": 56,
      "S": 70,
      "R": 55,
      "I": 78,
      "C": 68,
      "H": 100,
      "G": 88
    },
    "theme": "鲜活成长系",
    "keywords": [
      "机智通透",
      "乐观豁达",
      "赤子之心"
    ],
    "result_bg": "/assets/heroes/10_许七安_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/10_许七安_result_bg.png"
  },
  {
    "id": 11,
    "name": "韩立",
    "relation_type": "现实清醒·生存搭档",
    "one_liner": "他不保证为你与全世界为敌，他比较想先带你俩活着离开。",
    "why_him": "你嘴上可能要轰烈，真遇事却讨厌纯冲动，更信会判断进退的人。",
    "why_attracted": "你理解谨慎不是胆小，不会拿“爱不爱我”逼他做无意义冒险。",
    "how_love": "不花哨但有长期感，优先让两个人都安全。",
    "sweet_scene": "所有人觉得没路了，他说“先别急”，拿出你不知道什么时候准备的东西。",
    "flaw": "浪漫浓度偏低。",
    "conflict": "你想听情话，他先说现在不太安全。",
    "advice": "接受他的务实，也要主动提出你需要的情绪回应。",
    "final_line": "他不会给你一场拿命证明的爱情，他更想证明，两个人都好好活着，本身就是很难得的结局。",
    "front_cards": {
      "偏爱浓度": 80,
      "守护行动力": 90,
      "情绪理解力": 60,
      "心动危险值": 25
    },
    "vector": {
      "E": 28,
      "M": 54,
      "A": 89,
      "D": 34,
      "S": 80,
      "R": 18,
      "I": 96,
      "C": 82,
      "H": 42,
      "G": 78
    },
    "theme": "鲜活成长系",
    "keywords": [
      "现实清醒",
      "稳健生存",
      "长期主义"
    ],
    "result_bg": "/assets/heroes/11_韩立_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/11_韩立_result_bg.png"
  },
  {
    "id": 12,
    "name": "南珩/离十六",
    "relation_type": "双重身份·危险拉扯",
    "one_liner": "你以为系统给你匹配了两个人，后来发现麻烦了——都是他。",
    "why_him": "你很容易被反差拿捏，同一个人给你完全不同的关系体验。",
    "why_attracted": "你可能是少数能同时接受他不同面貌的人，不只爱某一张面具。",
    "how_love": "甜和风险都来自反差，你永远不知道下一秒看到哪一面。",
    "sweet_scene": "同一段关系里像同时遇见两种人。",
    "flaw": "隐瞒、身份差、试探都会放大信任问题。",
    "conflict": "你怀疑自己爱的是谁、哪一面是真的。",
    "advice": "反差可以迷人，但长期关系必须回到统一真实的自我。",
    "final_line": "真正让你上头的也许从来不是反差，而是终于有一个人愿意把所有不一样的自己，都交到你面前。",
    "front_cards": {
      "偏爱浓度": 91,
      "守护行动力": 86,
      "情绪理解力": 64,
      "心动危险值": 89
    },
    "vector": {
      "E": 60,
      "M": 58,
      "A": 84,
      "D": 82,
      "S": 56,
      "R": 89,
      "I": 88,
      "C": 76,
      "H": 46,
      "G": 67
    },
    "theme": "危险宿命系",
    "keywords": [
      "双重身份",
      "危险拉扯",
      "神秘深邃"
    ],
    "result_bg": "/assets/heroes/12_南珩_离十六_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/12_南珩_离十六_result_bg.png"
  },
  {
    "id": 13,
    "name": "梅逐雨",
    "relation_type": "禁欲纯情·低调强者",
    "one_liner": "别人家的英雄排场很大，你家的比较朴素——但是妖来了他真能上。",
    "why_him": "你对炫耀型强者不太感冒，真正安心的是平时普通、关键时刻非常能打的人。",
    "why_attracted": "你不拿他的朴素和寡言开玩笑，能理解价值和排场无关。",
    "how_love": "很认真，不一定会撩，但每一步都算数。",
    "sweet_scene": "你问“你是不是喜欢我？”他整个人卡住，半天才说“……是。”",
    "flaw": "过于正经，恋爱初期像在守纪律。",
    "conflict": "你在暧昧，他在认真执行人生大事。",
    "advice": "给他明确反馈，别用太多猜谜式暧昧。",
    "final_line": "真正可靠的人，不一定出场的时候最耀眼，而是在所有光都灭了以后，他依然站在那里。",
    "front_cards": {
      "偏爱浓度": 87,
      "守护行动力": 92,
      "情绪理解力": 76,
      "心动危险值": 35
    },
    "vector": {
      "E": 43,
      "M": 77,
      "A": 92,
      "D": 44,
      "S": 86,
      "R": 32,
      "I": 70,
      "C": 88,
      "H": 32,
      "G": 64
    },
    "theme": "清冷仙系",
    "keywords": [
      "禁欲纯情",
      "低调强者",
      "行动守护"
    ],
    "result_bg": "/assets/heroes/13_梅逐雨_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/13_梅逐雨_result_bg.png"
  },
  {
    "id": 14,
    "name": "萧蘅",
    "relation_type": "游刃掌局·暧昧高手",
    "one_liner": "你以为自己在和他暧昧，他可能连你下一步会怎么嘴硬都猜到了。",
    "why_him": "你容易被聪明但不紧绷、看得懂局势也看得懂你的人吸引。",
    "why_attracted": "你不是几句话就会被牵着走的人，这反而让掌局者觉得有趣。",
    "how_love": "你走一步他接一步，你以为跑出去了，回头他还在笑。",
    "sweet_scene": "整段关系像一场高质量过招。",
    "flaw": "太会控制节奏，让你怀疑到底是不是自己的选择。",
    "conflict": "这到底是我的决定还是又被你算到了？",
    "advice": "需要把博弈感和真实沟通分开。",
    "final_line": "最让你心动的可能不是一个永远领先你的人，而是一个明明看懂了你全部的招数，却依然愿意陪你继续玩下去的人。",
    "front_cards": {
      "偏爱浓度": 91,
      "守护行动力": 87,
      "情绪理解力": 80,
      "心动危险值": 78
    },
    "vector": {
      "E": 73,
      "M": 80,
      "A": 86,
      "D": 76,
      "S": 70,
      "R": 78,
      "I": 94,
      "C": 75,
      "H": 74,
      "G": 66
    },
    "theme": "智谋权谋系",
    "keywords": [
      "游刃掌局",
      "暧昧高手",
      "洞察人心"
    ],
    "result_bg": "/assets/heroes/14_萧蘅_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/14_萧蘅_result_bg.png"
  },
  {
    "id": 15,
    "name": "慕声",
    "relation_type": "黑莲花少年·危险缺爱",
    "one_liner": "他最难搞的地方不是危险，是一旦真的相信你，就会把这件事看得太重。",
    "why_him": "你容易对带刺、明明想被喜欢却表现得最难接近的人心软。",
    "why_attracted": "你看见防备、别扭和缺安全感后没有立刻嫌麻烦。",
    "how_love": "浓度高，一点反应都可能被放大很多倍。",
    "sweet_scene": "一旦确认你没有走，他会把这件事看得极重。",
    "flaw": "安全感容易失衡，甜是真的甜，累也可能真累。",
    "conflict": "小事很容易被放大成关系危机。",
    "advice": "稳定边界比无限迁就更重要。",
    "final_line": "你不是为了拯救谁而来到他的生命里，但真正被爱过的人，确实可能第一次愿意相信这个世界没有那么坏。",
    "front_cards": {
      "偏爱浓度": 96,
      "守护行动力": 88,
      "情绪理解力": 77,
      "心动危险值": 93
    },
    "vector": {
      "E": 78,
      "M": 76,
      "A": 86,
      "D": 70,
      "S": 48,
      "R": 95,
      "I": 71,
      "C": 54,
      "H": 50,
      "G": 72
    },
    "theme": "危险宿命系",
    "keywords": [
      "黑莲花少年",
      "危险缺爱",
      "极致依赖"
    ],
    "result_bg": "/assets/heroes/15_慕声_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/15_慕声_result_bg.png"
  },
  {
    "id": 16,
    "name": "宋墨",
    "relation_type": "少年将军·行动派",
    "one_liner": "你还在想怎么办，他可能已经骑马出城了。",
    "why_him": "你对行动特别敏感，说得再漂亮，真到事情上没反应就会迅速下头。",
    "why_attracted": "你不是等别人安排的人，强者反而容易爱上能跟得上他的人。",
    "how_love": "少废话，多行动。",
    "sweet_scene": "你说“没事”，他回“你觉得我信吗？”然后直接开始处理。",
    "flaw": "情绪处理比较直。",
    "conflict": "你要抱抱，他已经开始解决问题。",
    "advice": "先接情绪，再解决问题，会让关系更柔软。",
    "final_line": "你真正想要的不是一个替你赢的人，而是一个在你决定开战的时候，已经替你把马牵过来的人。",
    "front_cards": {
      "偏爱浓度": 92,
      "守护行动力": 95,
      "情绪理解力": 69,
      "心动危险值": 61
    },
    "vector": {
      "E": 63,
      "M": 66,
      "A": 95,
      "D": 69,
      "S": 75,
      "R": 62,
      "I": 72,
      "C": 86,
      "H": 44,
      "G": 83
    },
    "theme": "铁血将军系",
    "keywords": [
      "少年将军",
      "行动果决",
      "并肩守护"
    ],
    "result_bg": "/assets/heroes/16_宋墨_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/16_宋墨_result_bg.png"
  },
  {
    "id": 17,
    "name": "崔行舟",
    "relation_type": "腹黑算计·计划反噬",
    "one_liner": "他原本只想算计你，后来发现最难算的那一步是：自己认真了。",
    "why_him": "你容易对脑子多、不能完全相信但很有过招感的人产生复杂好感。",
    "why_attracted": "你没有按他的预期发展，这对习惯计算结果的人很致命。",
    "how_love": "前期像策略，后期逐渐失控。",
    "sweet_scene": "从“怎么让她按计划走”变成“她为什么又不高兴？”",
    "flaw": "聪明如果缺乏坦白就会变成操控。",
    "conflict": "你开始怀疑所有安排是不是都被他设计过。",
    "advice": "关系里必须保留真正的知情权和选择权。",
    "final_line": "爱情最有趣的地方，就是两个都以为自己很清醒的人，最后一起变成了变量。",
    "front_cards": {
      "偏爱浓度": 90,
      "守护行动力": 86,
      "情绪理解力": 62,
      "心动危险值": 82
    },
    "vector": {
      "E": 52,
      "M": 58,
      "A": 84,
      "D": 88,
      "S": 64,
      "R": 80,
      "I": 94,
      "C": 76,
      "H": 34,
      "G": 62
    },
    "theme": "智谋权谋系",
    "keywords": [
      "腹黑谋局",
      "掌控全局",
      "计划反噬"
    ],
    "result_bg": "/assets/heroes/17_崔行舟_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/17_崔行舟_result_bg.png"
  },
  {
    "id": 18,
    "name": "李莲花",
    "relation_type": "通透疏离·灵魂理解",
    "one_liner": "你需要的可能根本不是来救你的英雄，而是那个终于看懂你为什么一直这么累的人。",
    "why_him": "你已经没那么迷恋强大感，更在意跟这个人在一起能不能松下来。",
    "why_attracted": "你不执着逼他证明自己，更在意他现在是否自在。",
    "how_love": "爱很轻，不是因为浅，而是成熟感情不需要一直用力抓。",
    "sweet_scene": "很多时候只是安静陪你，把复杂人生说得很淡。",
    "flaw": "太会放下，你舍不得时他可能已经接受结果。",
    "conflict": "你想抓紧，他更相信顺其自然。",
    "advice": "把通透和逃避区分开，重要的关系仍要主动表达。",
    "final_line": "有些人不是为了改变你的命运而来，而是让你第一次明白，原来人生不用永远这么用力。",
    "front_cards": {
      "偏爱浓度": 79,
      "守护行动力": 72,
      "情绪理解力": 96,
      "心动危险值": 32
    },
    "vector": {
      "E": 35,
      "M": 96,
      "A": 70,
      "D": 20,
      "S": 68,
      "R": 28,
      "I": 92,
      "C": 65,
      "H": 82,
      "G": 58
    },
    "theme": "清冷仙系",
    "keywords": [
      "通透疏离",
      "灵魂理解",
      "淡泊松弛"
    ],
    "result_bg": "/assets/heroes/18_李莲花_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/18_李莲花_result_bg.png"
  },
  {
    "id": 19,
    "name": "笛飞声",
    "relation_type": "武痴怪人·非常规强者",
    "one_liner": "系统确认你的盖世英雄已经到了。唯一的问题是，他目前比较关心谁是天下第一。",
    "why_him": "你可能比自己以为的更烦套路，太会撩的人反而让你警惕。",
    "why_attracted": "你不要求他演，他是什么就是什么。",
    "how_love": "浪漫模块不全，但认定很直线。",
    "sweet_scene": "你问“为什么帮我？”他说“想帮。哪来那么多为什么？”",
    "flaw": "共情模块疑似没装全。",
    "conflict": "别人安慰半天，他只问“谁惹你了？”",
    "advice": "不要期待他自动读懂情绪，直接说需求最省心。",
    "final_line": "有时候最省心的爱，不是一个人多会说，而是他说出口的每一句，你都不用猜是真是假。",
    "front_cards": {
      "偏爱浓度": 78,
      "守护行动力": 94,
      "情绪理解力": 42,
      "心动危险值": 72
    },
    "vector": {
      "E": 24,
      "M": 40,
      "A": 96,
      "D": 72,
      "S": 43,
      "R": 76,
      "I": 50,
      "C": 67,
      "H": 25,
      "G": 48
    },
    "theme": "铁血将军系",
    "keywords": [
      "武痴强者",
      "行动直接",
      "胜负执念"
    ],
    "result_bg": "/assets/heroes/19_笛飞声_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/19_笛飞声_result_bg.png"
  },
  {
    "id": 20,
    "name": "相柳",
    "relation_type": "克制牺牲·极致意难平",
    "one_liner": "他大概不是最会留下来的那个人，却可能是替你挡掉最多事情、又最不想让你知道的人。",
    "why_him": "你容易被表面疏离、内里极深，没有说出口却替你挡风雨的人击中。",
    "why_attracted": "你身上的生活牵挂和对未来的具体希望，是他自己很少拥有的东西。",
    "how_love": "很多爱发生在你看不见的地方，不邀功、不解释。",
    "sweet_scene": "多年后你突然知道：原来那一次，也是他。",
    "flaw": "太会牺牲、太会退出，不说的爱有时和没有很像。",
    "conflict": "为什么你什么都不告诉我？",
    "advice": "克制可以浪漫，但长期关系最终需要表达。",
    "final_line": "有的人来过，是为了陪你走到最后；有的人来过，是为了让你以后的人生能够继续往前走。",
    "front_cards": {
      "偏爱浓度": 97,
      "守护行动力": 98,
      "情绪理解力": 86,
      "心动危险值": 92
    },
    "vector": {
      "E": 22,
      "M": 84,
      "A": 99,
      "D": 70,
      "S": 36,
      "R": 94,
      "I": 74,
      "C": 100,
      "H": 20,
      "G": 44
    },
    "theme": "清冷仙系",
    "keywords": [
      "清冷克制",
      "深情守护",
      "宿命羁绊"
    ],
    "result_bg": "/assets/heroes/20_相柳_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/20_相柳_result_bg.png"
  },
  {
    "id": 21,
    "name": "涂山璟",
    "relation_type": "温柔稳定·确定选择",
    "one_liner": "有些英雄不是来制造剧情的，是来让你终于不用每天过剧情的。",
    "why_him": "你其实比自己想象中更需要稳定，真正谈关系越来越在意他是不是一直在。",
    "why_attracted": "你给他的不是征服感，是家。",
    "how_love": "不抢、不压、不替你决定，但一直给你“可以回来”的确定感。",
    "sweet_scene": "普通日子里始终稳定地选择你。",
    "flaw": "刺激度偏低，高浓度拉扯爱好者可能觉得太平静。",
    "conflict": "你会怀疑是不是少了点心动。",
    "advice": "稳定关系也需要主动创造新鲜感和共同目标。",
    "final_line": "真正珍贵的偏爱，有时候不是轰轰烈烈地选择你一次，而是在漫长的日子里，一次又一次还是选择你。",
    "front_cards": {
      "偏爱浓度": 94,
      "守护行动力": 82,
      "情绪理解力": 95,
      "心动危险值": 21
    },
    "vector": {
      "E": 82,
      "M": 98,
      "A": 80,
      "D": 22,
      "S": 99,
      "R": 16,
      "I": 66,
      "C": 60,
      "H": 40,
      "G": 70
    },
    "theme": "温润公子系",
    "keywords": [
      "温柔润泽",
      "包容体贴",
      "疗愈守护"
    ],
    "result_bg": "/assets/heroes/21_涂山璟_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/21_涂山璟_result_bg.png"
  },
  {
    "id": 22,
    "name": "玱玹",
    "relation_type": "权力野心·复杂深情",
    "one_liner": "他不是不爱你，他只是想要的世界，可能比一段爱情大得多。",
    "why_him": "你容易被有目标、有野心、有责任感的人吸引，因为方向感本身就很强。",
    "why_attracted": "你让他在所有大事之外，还记得自己也是普通人。",
    "how_love": "爱得深但不轻松，你永远要和使命、位置、未来争时间。",
    "sweet_scene": "短暂的普通时刻会成为他最舍不得的部分。",
    "flaw": "爱情很难永远排第一。",
    "conflict": "他爱你和这段关系适不适合你，是两道不同的题。",
    "advice": "明确彼此对优先级和未来的现实预期。",
    "final_line": "有些人可以给你最深的感情，却未必能给你最简单的人生。",
    "front_cards": {
      "偏爱浓度": 93,
      "守护行动力": 85,
      "情绪理解力": 74,
      "心动危险值": 81
    },
    "vector": {
      "E": 55,
      "M": 70,
      "A": 84,
      "D": 86,
      "S": 57,
      "R": 82,
      "I": 91,
      "C": 98,
      "H": 34,
      "G": 60
    },
    "theme": "智谋权谋系",
    "keywords": [
      "权力野心",
      "责任大局",
      "复杂深情"
    ],
    "result_bg": "/assets/heroes/22_玱玹_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/22_玱玹_result_bg.png"
  },
  {
    "id": 23,
    "name": "澹台烬",
    "relation_type": "极端宿命·高浓度爱",
    "one_liner": "这不是细水长流，是一场开始之前最好先确认自己系没系安全带的爱情。",
    "why_him": "你心里仍藏着一点想被一个人爱得非常确定、非常重的愿望。",
    "why_attracted": "对长期不相信感情的人来说，一旦出现真正重要的人，这种重要会迅速失控。",
    "how_love": "爱很重，浓度极高。",
    "sweet_scene": "所有情绪都像被拉到最大音量。",
    "flaw": "边界感是最大风险。",
    "conflict": "“我不能失去你”很容易变成“所以你不能离开我”。",
    "advice": "真正好的爱情不靠失控证明，边界必须清楚。",
    "final_line": "最好的结局不是有人因为你失去整个世界，而是他终于因为爱你，学会怎样和这个世界相处。",
    "front_cards": {
      "偏爱浓度": 99,
      "守护行动力": 91,
      "情绪理解力": 69,
      "心动危险值": 99
    },
    "vector": {
      "E": 88,
      "M": 62,
      "A": 91,
      "D": 92,
      "S": 35,
      "R": 100,
      "I": 68,
      "C": 48,
      "H": 20,
      "G": 58
    },
    "theme": "危险宿命系",
    "keywords": [
      "宿命纠缠",
      "危险心动",
      "极致占有"
    ],
    "result_bg": "/assets/heroes/23_澹台烬_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/23_澹台烬_result_bg.png"
  },
  {
    "id": 24,
    "name": "东方青苍",
    "relation_type": "顶级强者·霸气护短",
    "one_liner": "全世界都觉得他很难哄，只有你发现：好像也没有那么难。",
    "why_him": "你确实吃强者感，但真正喜欢的是那么强的人偏偏把柔软留给你。",
    "why_attracted": "你不只需要他的力量，也会在意他今天开不开心。",
    "how_love": "前期“荒唐”，中期“顺便”，后期“谁欺负你了？”",
    "sweet_scene": "强者式解决问题，却在你这里出现巨大反差。",
    "flaw": "主导欲太强，习惯觉得自己处理更快。",
    "conflict": "保护很容易变成替你决定。",
    "advice": "力量之外也要尊重你的选择权。",
    "final_line": "真正让强者变温柔的，从来不是更大的力量，而是终于出现一个他舍不得用力量对待的人。",
    "front_cards": {
      "偏爱浓度": 96,
      "守护行动力": 98,
      "情绪理解力": 72,
      "心动危险值": 86
    },
    "vector": {
      "E": 66,
      "M": 68,
      "A": 99,
      "D": 95,
      "S": 65,
      "R": 88,
      "I": 72,
      "C": 85,
      "H": 38,
      "G": 62
    },
    "theme": "危险宿命系",
    "keywords": [
      "顶级强者",
      "霸气护短",
      "极致偏爱"
    ],
    "result_bg": "/assets/heroes/24_东方青苍_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/24_东方青苍_result_bg.png"
  },
  {
    "id": 25,
    "name": "凌不疑",
    "relation_type": "狠厉复仇·极致偏爱",
    "one_liner": "他的偏爱非常明显。问题是，他的仇也非常明显。",
    "why_him": "你容易对外冷内重、对所有人戒备却对你例外的人上头。",
    "why_attracted": "你不是因为他强才靠近，甚至会在他走太远时直接说“不行”。",
    "how_love": "有事处理、危险挡、偏爱几乎不藏。",
    "sweet_scene": "所有人都看得出他的选择站在哪边。",
    "flaw": "秘密和执念太重。",
    "conflict": "你口口声声说保护我，但到底把不把我当自己人？",
    "advice": "真正的保护应该包含知情权。",
    "final_line": "他可以替你挡住很多东西，但真正决定你们能不能走到最后的，是他什么时候愿意停止一个人扛完整个世界。",
    "front_cards": {
      "偏爱浓度": 98,
      "守护行动力": 99,
      "情绪理解力": 65,
      "心动危险值": 90
    },
    "vector": {
      "E": 58,
      "M": 57,
      "A": 100,
      "D": 90,
      "S": 58,
      "R": 92,
      "I": 80,
      "C": 96,
      "H": 28,
      "G": 60
    },
    "theme": "铁血将军系",
    "keywords": [
      "狠厉复仇",
      "极致偏爱",
      "铁血守护"
    ],
    "result_bg": "/assets/heroes/25_凌不疑_result_bg.webp",
    "result_bg_source_png": "07_正式人物素材/盖世英雄_25人物正式首屏素材_V1/25_凌不疑_result_bg.png"
  }
]
